// File#: _1_helper

(function () {
    // Helper function
    function Helper() { };

    // Debouncer for resize. Fire resize event resize has been still for 200ms. 
    Helper.Debouncer = function (func, timeout) {
        var timeoutID, timeout = timeout || 200;
        return function () {
            var scope = this, args = arguments;
            clearTimeout(timeoutID);
            timeoutID = setTimeout(function () {
                func.apply(scope, Array.prototype.slice.call(args));
            }, timeout);
        }
    }

    Helper.ScrollTo = function (pos, time) {
        var currentPos = window.pageYOffset;
        var start = null;
        if (time == null) time = 500;
        pos = +pos, time = +time;
        window.requestAnimationFrame(function step(currentTime) {
            start = !start ? currentTime : start;
            var progress = currentTime - start;
            if (currentPos < pos) {
                window.scrollTo(0, ((pos - currentPos) * progress / time) + currentPos);
            } else {
                window.scrollTo(0, currentPos - ((currentPos - pos) * progress / time));
            }
            if (progress < time) {
                window.requestAnimationFrame(step);
            } else {
                window.scrollTo(0, pos);
            }
        });
    };

    Helper.GetCurrentNodeId = function () {
        return document.body.dataset.currentNode;
    }

    window.Helper = Helper;

}());